import { Widget } from '~/services/OrganizationService';
import { Candidate, WorkAuthorization } from '~/services/types/candidate';
import { User } from '~/services/types/identity';

interface WidgetState {
    schoolWidgets: Widget[] | null;
    globalWidgets: Widget[] | null;
}

export default {
    namespaced: true,
    state: {
        schoolWidgets: null,
        globalWidgets: null,
    } as WidgetState,
    getters: {
        getAllWidgets: (state: WidgetState) => () => {
            return [...(state.schoolWidgets || []), ...(state.globalWidgets || [])];
        },
        getSchoolWidgets: (state: WidgetState) => () => state.schoolWidgets,
        getGlobalWidgets: (state: WidgetState) => () => state.globalWidgets,
    },
    mutations: {
        setSchoolWidgets(state: WidgetState, schoolWidgets: Widget[] | null) {
            state.schoolWidgets = schoolWidgets;
        },
        setGlobalWidgets(state: WidgetState, globalWidgets: Widget[] | null) {
            state.globalWidgets = globalWidgets;
        },
        clear() {
            return {
                schoolWidgets: null,
                globalWidgets: null,
            };
        },
    },
};
